const items = [
  "Moda → IA",
  "◆",
  "Sin producciones",
  "◆",
  "Tienda · IG · TikTok",
  "◆",
  "Sin sesiones de fotos",
  "◆",
  "Hecho para tu marca",
  "◆",
];

export function Marquee() {
  const track = [...items, ...items];
  return (
    <section
      aria-hidden="true"
      className="relative border-y border-white/10 py-5 md:py-6 overflow-hidden marquee-mask bg-[rgb(var(--ink-2))]/40"
    >
      <div className="flex whitespace-nowrap marquee-track" data-testid="marquee">
        {track.map((t, i) => (
          <div key={i} className="flex items-center gap-8 md:gap-12 pr-8 md:pr-12">
            <span
              className={
                t === "◆"
                  ? "text-[rgb(var(--brand))] text-2xl md:text-3xl leading-none"
                  : "font-display font-light text-[5.5vw] md:text-[3.5vw] leading-none text-[rgb(var(--paper))]"
              }
            >
              {t}
            </span>
          </div>
        ))}
      </div>
    </section>
  );
}
